import axiosInstanceToken from '@/lib/axiosInstanceToken';
import { AxiosPromise } from 'axios';
import {
  ListSSHInstancesResponse,
  RunSSHPayload,
  TerminateSSHResponse,
} from './type';

export const listSSHInstances = async (
  token: string
): Promise<ListSSHInstancesResponse> => {
  const baseUrl = axiosInstanceToken.defaults.baseURL || '';
  const response = await fetch(`${baseUrl}/task/ssh/list`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
};

export const runSSHInstanceSSE = async (
  payload: RunSSHPayload,
  token: string
): Promise<Response> => {
  const baseUrl = axiosInstanceToken.defaults.baseURL || '';
  const response = await fetch(`${baseUrl}/task/run/ssh`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response;
};

export const cancelSSHInstance = async (
  taskId: string,
  token: string,
  reason: string = 'user_requested'
): Promise<{ status: string; task_id: string; details: string }> => {
  const baseUrl = axiosInstanceToken.defaults.baseURL || '';
  const response = await fetch(`${baseUrl}/task/cancel/${taskId}?reason=${encodeURIComponent(reason)}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
};

export const stopSSHInstance = async (
  taskId: string
): Promise<{ status: string }> => {
  const { data } = await axiosInstanceToken.post<{ status: string }>(`/task/ssh/stop`, {
    task_id: taskId,
  });
  return data;
};

export const renameSSHInstance = async (
  projectId: string,
  projectName: string,
  token: string
): Promise<any> => {
  const baseUrl = axiosInstanceToken.defaults.baseURL || '';
  const response = await fetch(`${baseUrl}/project/${projectId}/to/${encodeURIComponent(projectName)}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
};

export const terminateSSHInstance = async (
  taskId: string,
  token: string
): Promise<TerminateSSHResponse> => {
  const baseUrl = axiosInstanceToken.defaults.baseURL || '';
  const response = await fetch(`${baseUrl}/task/ssh/${taskId}/terminate`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
};
